import { render, staticRenderFns } from "./editeAreaCompoment.vue?vue&type=template&id=71c68380&scoped=true&"
import script from "./editeAreaCompoment.vue?vue&type=script&lang=js&"
export * from "./editeAreaCompoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c68380",
  null
  
)

export default component.exports